<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="custom-report" v-else>
      <b-overlay
        :show="loadData"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="md"
      >
        <div class="report-header-image-section border rounded p-3 mb-4">
          <b-form-checkbox
            v-model="reportHeaderImageEnabled"
            @change="onReportHeaderImageEnabledChange"
          >
            Enable Report Header Image
          </b-form-checkbox>

          <div v-if="reportHeaderImageEnabled" class="d-flex align-items-center mt-3">
            <img
              v-if="reportHeaderImagePreview"
              :src="reportHeaderImagePreview"
              alt="Report Header Image"
              class="report-header-image-preview mr-3"
              @click="triggerReportHeaderImageInput"
            />
            <div
              v-else
              class="report-header-image-placeholder mr-3 d-flex align-items-center justify-content-center"
              @click="triggerReportHeaderImageInput"
            >
              <i class="fas fa-image text-secondary"></i>
            </div>
            <div>
              <b-form-file
                ref="reportHeaderImageInput"
                accept="image/*"
                style="display: none"
                @change="onReportHeaderImageChange"
              ></b-form-file>
              <b-button
                size="sm"
                variant="outline-info"
                :disabled="uploadingReportHeaderImage"
                @click="triggerReportHeaderImageInput"
              >
                {{ reportHeaderImagePreview ? "Change Image" : "Upload Image" }}
              </b-button>
            </div>
          </div>
        </div>

        <div class="addCustomRow" v-if="editState">
          <AddCustomRow
            :reportsOptions="reportsOptions"
            :templatesOptions="templatesOptions"
            :templatesObject="templatesObject"
            @cancelCustomReport="cancelCustomReport"
          />
        </div>
        <div v-else>
          <b-button
            size="sm"
            variant="primary"
            class="mb-2"
            @click="editState = !editState"
            >+ Add/Edit</b-button
          >

          <div class="table responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr class="text-left">
                  <th>Report</th>
                  <th>Template</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report, reportIndex) in customReports" :key="reportIndex">
                  <td class="align-middle">
                    <p>
                      {{ report.report }}
                    </p>
                  </td>
                  <td class="align-middle">
                    <p>
                      {{ report.template }}
                    </p>
                  </td>
                  <td class="align-middle">
                    <span
                      class="text-danger btn p-0 m-0"
                      @click="deleteCustomReport(report.id, reportIndex)"
                    >
                      <i class="fas fa-trash"></i>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import AddCustomRow from "./AddCustomRow.vue";
export default {
  async created() {
    this.fetchData = true;
    await this.getCustomReportsOptions();
    await this.getCustomReports();
    await this.loadReportHeaderImageSetting();
    this.fetchData = false;
  },
  components: {
    AddCustomRow,
  },
  computed: {
    cloudStorageRoot() {
      return this.$store.getters.getAPIKey.userAttachments;
    },
  },
  data() {
    return {
      fetchData: false,
      loadData: false,
      customReports: [],
      existingCustomReports: [],
      customReportsOptions: [],
      reportsOptions: [],
      templatesOptions: [],
      templatesObject: {},
      editState: false,

      reportHeaderImageEnabled: false,
      reportHeaderImagePreview: null,
      uploadingReportHeaderImage: false,

      tempo:
        '<table class="table table-bordered table-striped"><thead class="thead-dark"><tr><th colspan="2"><img src="data:image/jpeg;base64,{{ base64_encode(@file_get_contents(url("https://picsum.photos/id/237/200/300"))) }}" alt="Italian Trulli"><strong style="font-size: 18px;">variable_instituteName</strong> </th></tr><tr><th colspan="2">variable_reportName</th></tr></thead></table>',
    };
  },
  methods: {
    async loadReportHeaderImageSetting() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institution/setting/report_header_image_enabled`;
      const response = await this.$axios.get(url);
      this.reportHeaderImageEnabled = !!response.data;

      const institutionId = this.$store.getters.getCurrentInstitution.id;
      const institutionUrl =
        this.$store.getters.getAPIKey.mainAPI + `/institutions/${institutionId}`;
      const institutionResponse = await this.$axios.get(institutionUrl);
      const institution = institutionResponse.data;

      this.$store.commit("getCurrentInstitution", institution);

      if (institution && institution.report_header_image) {
        this.reportHeaderImagePreview =
          this.cloudStorageRoot +
          institution.report_header_image.file_path +
          institution.report_header_image.file_name;
      }
    },
    async onReportHeaderImageEnabledChange(value) {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/institution/setting/report_header_image_enabled`;
      await this.$axios.post(url, { report_header_image_enabled: value });
    },
    triggerReportHeaderImageInput() {
      this.$refs.reportHeaderImageInput.$el
        .querySelector('input[type="file"]')
        .click();
    },
    onReportHeaderImageChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async () => {
        this.reportHeaderImagePreview = reader.result;
        await this.uploadReportHeaderImage(reader.result);
      };
      reader.readAsDataURL(file);
    },
    async uploadReportHeaderImage(base64Image) {
      this.uploadingReportHeaderImage = true;
      const institution = this.$store.getters.getCurrentInstitution;
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/institutions/${institution.id}`;
      await this.$axios
        .put(url, { base64_report_header_image: base64Image })
        .then((response) => {
          this.$store.commit("getCurrentInstitution", response.data);
          this.$toast.success("Report header image updated", {
            position: "top",
            duration: 3000,
          });
        })
        .catch(() => {
          this.$toast.error("Something went wrong, please try again!", {
            position: "top",
            duration: 3000,
          });
        });
      this.uploadingReportHeaderImage = false;
    },
    cancelCustomReport(status) {
      if (status) {
        this.editState = !this.editState;
        this.getCustomReports();
      } else {
        this.editState = !this.editState;
      }
    },
    async getCustomReports() {
      this.fetchData = true;
      const url = this.$store.getters.getAPIKey.mainAPI + `/customreports`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.customReports = [];
          this.editState = false;
          const existingCustomReports = response.data;
          existingCustomReports.forEach((report) => {
            this.customReports.push({
              id: report.id,
              report: report.report,
              template: report.template,
              // variables: report.variables,
            });
          });

          response;
        })
        .catch((error) => {
          error;
        });
      this.fetchData = false;
    },
    async deleteCustomReport(reportId, reportIndex) {
      this.loadData = true;
      const url = this.$store.getters.getAPIKey.mainAPI + `/customreports/${reportId}`;
      await this.$axios
        .delete(url)
        .then((response) => {
          this.customReports.splice(reportIndex, 1);
          this.$toast.success("Removed Successfully", {
            position: "top",
            duration: 3000,
          });
          response;
        })
        .catch((error) => {
          error;
        });
      this.loadData = false;
    },
    async getCustomReportsOptions() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/customreports/options`;
      await this.$axios
        .get(url)
        .then((response) => {
          const reports = response.data.reports;
          const templates = response.data.templates;
          this.reportsOptions = [{ value: null, text: "Select Report" }];
          this.templatesOptions = [{ value: null, text: "Select Template" }];
          reports.forEach((report) => {
            this.reportsOptions.push({
              value: report.key,
              text: report.key,
            });
          });
          for (let template in templates) {
            this.templatesOptions.push({
              value: template,
              text: template,
            });
            const templateObject = {};
            templates[template].variables.forEach((temp) => {
              this.$set(templateObject, temp.key, {
                value: null,
                attributes: temp.attributes.length != 0 ? temp.attributes[0] : "",
              });
            });
            this.$set(this.templatesObject, template, templateObject);
          }

          response;
        })
        .catch((error) => {
          error;
        });
    },
  },
};
</script>

<style >
.custom-report i {
  font-size: 12px !important;
}

.report-header-image-preview {
  width: 80px;
  height: 80px;
  object-fit: contain;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  cursor: pointer;
  background: #fff;
}

.report-header-image-placeholder {
  width: 80px;
  height: 80px;
  border: 1px dashed #adb5bd;
  border-radius: 5px;
  cursor: pointer;
  font-size: 28px;
}
</style>
